<div class="ia-page">

  <!-- header + stepper -->
  <header class="ia-header" *ngIf="!embutido">
    <button type="button" class="ia-back-btn" (click)="volteParaProdutos()">
      <span class="fa fa-arrow-left"></span>
      <span class="ia-back-label">Produtos</span>
    </button>

    <span class="ia-header__divisor"></span>

    <div class="ia-heading">
      <h1>Importar cardápio com IA</h1>
      <p class="ia-subtitle" *ngIf="etapa === 'revisar' && rascunho">
        {{ totalProdutos }} produtos · {{ totalGrupos }} grupos · {{ totalOpcoes }} opções
      </p>
    </div>

    <!-- custo da chamada de IA: só admins do MeuCardápio veem -->
    <span class="ia-custo-admin" *ngIf="resumoCustoAnalise && (etapa === 'revisar' || etapa === 'concluir')"
          title="Custo da análise (visível apenas para admins do MeuCardápio)">
      <span class="fa fa-dollar-sign"></span> {{ resumoCustoAnalise }}
    </span>

    <span class="ia-beta">Beta</span>
  </header>

  <!-- fluxo de etapas -->
  <nav class="ia-fluxo" aria-label="Etapas da importação">
    <div class="ia-fluxo__item" *ngFor="let item of etapas; let indice = index; let ultimo = last"
         [class.is-ativa]="estadoEtapa(item.id) === 'ativa'"
         [class.is-concluida]="estadoEtapa(item.id) === 'concluida'"
         [class.is-erro]="estadoEtapa(item.id) === 'ativa' && !!erroAnalise">
      <div class="ia-fluxo__topo">
        <span class="ia-fluxo__dot">
          <span class="fa fa-check" *ngIf="estadoEtapa(item.id) === 'concluida'"></span>
          <span class="fa fa-times" *ngIf="estadoEtapa(item.id) === 'ativa' && erroAnalise"></span>
          <ng-container *ngIf="estadoEtapa(item.id) !== 'concluida' && !(estadoEtapa(item.id) === 'ativa' && erroAnalise)">
            {{ indice + 1 }}
          </ng-container>
        </span>
        <span class="ia-fluxo__linha" *ngIf="!ultimo"></span>
      </div>
      <p class="ia-fluxo__rotulo">{{ indice + 1 }}. {{ item.rotulo }}</p>
      <p class="ia-fluxo__sub">{{ item.descricao }}</p>
    </div>
  </nav>

  <!-- ═══════════ ETAPA 1: ENVIAR ═══════════ -->
  <section class="ia-etapa ia-etapa--enviar" *ngIf="etapa === 'enviar'">
    <div class="ia-solo">
      <div class="ia-card ia-card--secoes">
        <div class="ia-card__secao">
          <div class="ia-dropzone"
               [class.is-arrastando]="arrastando"
               (click)="abraSeletorDeArquivo(inputArquivo)"
               (dragenter)="aoEntrarArrasto($event)"
               (dragover)="aoArrastarSobre($event)"
               (dragleave)="aoSairArrasto($event)"
               (drop)="aoSoltarArquivos($event)">
            <span class="ia-dropzone__icone">
              <span class="fa fa-upload"></span>
            </span>
            <p class="ia-dropzone__titulo">Arraste o PDF ou as fotos do cardápio aqui</p>
            <p class="ia-dropzone__ou">
              ou
              <label class="ia-link" (click)="$event.stopPropagation()">
                escolha os arquivos
                <input #inputArquivo type="file" class="ia-input-arquivo" multiple
                       accept=".pdf,.jpg,.jpeg,.png,.webp"
                       (change)="aoEscolherArquivos($event)">
              </label>
              do computador
            </p>
            <p class="ia-dropzone__limites">PDF (1 arquivo · até 10 MB) ou fotos JPG, PNG e WebP (até 10 · 5 MB cada)</p>
          </div>

          <div class="ia-arquivos" *ngIf="arquivos.length > 0">
            <div class="ia-arquivo" *ngFor="let arquivo of arquivos; let indice = index"
                 [class.is-invalido]="arquivo.erro">
              <!-- prévia do PDF: o próprio navegador renderiza o blob, sem biblioteca; clique abre o arquivo inteiro -->
              <button type="button" class="ia-arquivo__thumb ia-arquivo__thumb--pdf" *ngIf="arquivo.previewPdfUrl"
                      (click)="abraArquivo(arquivo)" title="Abrir o PDF em outra aba" aria-label="Abrir o PDF em outra aba">
                <iframe [src]="arquivo.previewPdfUrl" title="Prévia do PDF" tabindex="-1" scrolling="no"></iframe>
              </button>

              <span class="ia-arquivo__thumb" *ngIf="!arquivo.previewPdfUrl"
                    [class.ia-arquivo__thumb--foto]="arquivo.previewUrl">
                <img *ngIf="arquivo.previewUrl" [src]="arquivo.previewUrl" alt="">
                <span class="fa" *ngIf="!arquivo.previewUrl" [class.fa-file-pdf-o]="arquivo.tipo === 'pdf'"
                      [class.fa-image]="arquivo.tipo === 'imagem'"></span>
              </span>

              <div class="ia-arquivo__info">
                <strong>{{ arquivo.nome }}</strong>
                <small *ngIf="!arquivo.erro">{{ arquivo.tamanho }}</small>
                <small class="ia-arquivo__erro" *ngIf="arquivo.erro">{{ arquivo.erro }}</small>
              </div>

              <button type="button" class="ia-icon-btn" (click)="removaArquivo(indice)" aria-label="Remover arquivo">
                <span class="fa fa-times"></span>
              </button>
            </div>
          </div>

          <p class="ia-erro" *ngIf="erroEnvio">{{ erroEnvio }}</p>
        </div>

        <div class="ia-card__secao ia-card__secao--checklist">
          <h3>Melhores resultados quando o cardápio tem</h3>
          <ul class="ia-checklist">
            <li><span class="fa fa-check"></span> Texto selecionável (PDF) ou fotos nítidas</li>
            <li><span class="fa fa-check"></span> Preço ao lado de cada item</li>
            <li><span class="fa fa-check"></span> Seções nomeadas (Lanches, Bebidas)</li>
          </ul>
        </div>

        <footer class="ia-card__secao ia-card__rodape">
          <span class="ia-rodape__hint" *ngIf="arquivos.length === 0">Envie um arquivo para continuar</span>
          <div class="ia-rodape__acoes">
            <button type="button" class="ia-ghost-btn" (click)="volteParaProdutos()">Cancelar</button>
            <button type="button" class="ia-primary-btn" (click)="analiseCardapio()" [disabled]="!podeAnalisar">
              Importar Cardápio
            </button>
          </div>
        </footer>
      </div>
    </div>
  </section>

  <!-- ═══════════ ETAPA 2: ANALISAR ═══════════ -->
  <section class="ia-etapa ia-etapa--analisar" *ngIf="etapa === 'analisar'">
    <div class="ia-solo">
      <div class="ia-card">

        <ng-container *ngIf="!erroAnalise">
          <div class="ia-status-head">
            <span class="ia-analise__icone">
              <span class="fa fa-magic"></span>
            </span>
            <div class="ia-status-head__textos">
              <h2 class="ia-analise__titulo">Analisando seu cardápio</h2>
              <p class="ia-analise__arquivo" *ngIf="resumoSelecao">
                {{ resumoSelecao }}<ng-container *ngIf="arquivos[0].tipo === 'pdf'"> · {{ arquivos[0].tamanho }}</ng-container>
              </p>
            </div>
          </div>

          <p class="ia-frase-chef" *ngIf="fraseChef"
             [class.is-a]="alternadorFrase" [class.is-b]="!alternadorFrase">
            <span class="fa fa-cutlery"></span> {{ fraseChef }}
          </p>

          <div class="ia-barra">
            <div class="ia-barra__trilha">
              <div class="ia-barra__preenchimento" [style.width.%]="progressoBarra"></div>
            </div>
            <span class="ia-barra__percentual">{{ percentualBarra }}%</span>
          </div>

          <ul class="ia-analise__etapas">
            <li *ngFor="let item of etapasAnalise"
                [class.is-concluida]="item.estado === 'concluida'"
                [class.is-ativa]="item.estado === 'ativa'">
              <span class="ia-analise__marcador">
                <span class="fa fa-check" *ngIf="item.estado === 'concluida'"></span>
                <span class="fa fa-circle-notch fa-spin" *ngIf="item.estado === 'ativa'"></span>
              </span>
              <span class="ia-analise__rotulo">{{ item.rotulo }}</span>
            </li>
          </ul>

          <p class="ia-analise__parcial" *ngIf="progressoAnalise?.produtos">
            Encontrados até agora:
            <strong>{{ progressoAnalise.produtos }}
              {{ progressoAnalise.produtos === 1 ? 'produto' : 'produtos' }}</strong>
            <ng-container *ngIf="progressoAnalise.categorias">
              · {{ progressoAnalise.categorias }}
              {{ progressoAnalise.categorias === 1 ? 'categoria' : 'categorias' }}
            </ng-container>
          </p>

          <p class="ia-dica">
            <span class="fa fa-info-circle"></span>
            Isso leva de alguns segundos a poucos minutos, dependendo do tamanho do cardápio.
            Mantenha esta janela aberta.
          </p>
        </ng-container>

        <ng-container *ngIf="erroAnalise">
          <div class="ia-status-head">
            <span class="ia-analise__icone ia-analise__icone--erro">
              <span class="fa fa-times"></span>
            </span>
            <div class="ia-status-head__textos">
              <h2 class="ia-analise__titulo">Não conseguimos ler este cardápio</h2>
              <p class="ia-analise__arquivo" *ngIf="resumoSelecao">
                {{ resumoSelecao }}<ng-container *ngIf="arquivos[0].tipo === 'pdf'"> · {{ arquivos[0].tamanho }}</ng-container>
              </p>
            </div>
          </div>

          <p class="ia-analise__erro">{{ erroAnalise }}</p>

          <footer class="ia-card__footer">
            <button type="button" class="ia-ghost-btn" (click)="envieOutroArquivo()">Enviar outro arquivo</button>
            <button type="button" class="ia-primary-btn" (click)="tenteAnalisarNovamente()">Tentar novamente</button>
          </footer>
        </ng-container>
      </div>
    </div>
  </section>

  <!-- ═══════════ ETAPA 3: REVISAR ═══════════ -->
  <section class="ia-etapa ia-etapa--revisar" *ngIf="etapa === 'revisar'">

    <div class="ia-filtros" *ngIf="rascunho">
      <div class="ia-filtros__pills">
        <button type="button" class="ia-pill" [class.is-ativa]="filtro === 'todos'"
                (click)="defineFiltro('todos')">Todos {{ totalProdutos }}</button>
        <button type="button" class="ia-pill" [class.is-ativa]="filtro === 'pendencias'"
                (click)="defineFiltro('pendencias')">Com pendência {{ totalComPendencia }}</button>
        <button type="button" class="ia-pill" [class.is-ativa]="filtro === 'prontos'"
                (click)="defineFiltro('prontos')">Prontos {{ totalProntos }}</button>
      </div>

      <label class="ia-busca">
        <span class="fa fa-search"></span>
        <input type="text" placeholder="Buscar produto" [(ngModel)]="busca" name="buscaRevisao">
      </label>
    </div>

    <div class="ia-revisao" *ngIf="rascunho">

      <!-- sidebar de categorias -->
      <aside class="ia-sidebar">
        <div class="ia-sidebar__card">
          <h3>Categorias</h3>
          <button type="button" class="ia-sidebar__item" *ngFor="let categoria of categorias; trackBy: trackPorReferencia"
                  (click)="vaParaCategoria(categoria)">
            <span class="ia-sidebar__nome">{{ categoria.draft.nome || 'Sem nome' }}</span>
            <span class="ia-sidebar__badge ia-sidebar__badge--pendencia" *ngIf="categoria.totalPendencias > 0">
              ⚠ {{ categoria.totalPendencias }}
            </span>
            <span class="ia-sidebar__badge">{{ categoria.produtos.length }}</span>
          </button>

          <button type="button" class="ia-sidebar__pendencias" *ngIf="totalPendencias > 0"
                  (click)="vaParaProximaPendencia()">
            <span class="fa fa-exclamation-triangle"></span>
            {{ totalPendencias }} {{ totalPendencias === 1 ? 'pendência' : 'pendências' }}
            <span class="fa fa-angle-right"></span>
          </button>
        </div>
      </aside>

      <!-- lista de produtos -->
      <div class="ia-lista">

        <section class="ia-card" *ngIf="temPizzas && rascunho.configuracaoPizza as configuracao">
          <h3>Configuração das pizzas</h3>
          <p>
            <strong>Template:</strong> {{ nomeTemplatePizza }}
            <small *ngIf="templatePizzaExistente">· será reutilizado</small>
          </p>
          <p class="ia-erro" *ngIf="erroTemplatePizza">{{ erroTemplatePizza }}</p>

          <label class="ia-campo">
            <span>Cobrar pizza com vários sabores pelo</span>
            <select [(ngModel)]="configuracao.tipoCobranca"
                    [disabled]="!!templatePizzaExistente || carregandoTemplatePizza"
                    (ngModelChange)="aoEditarConfiguracaoPizza()">
              <option [ngValue]="'MAIOR'">Sabor de maior preço</option>
              <option [ngValue]="'MEDIA'">Preço médio dos sabores</option>
            </select>
          </label>

          <div class="ia-grupos">
            <h4>Tamanhos — configure uma vez para todos os sabores</h4>
            <div class="ia-campo-linha" *ngFor="let tamanho of configuracao.tamanhos">
              <label class="ia-campo">
                <span>Nome</span>
                <input type="text" [ngModel]="tamanho.nome"
                       [disabled]="tamanhoExisteNoTemplate(tamanho)"
                       (ngModelChange)="renomeieTamanhoPizza(tamanho, $event)">
              </label>
              <label class="ia-campo">
                <span>Pedaços</span>
                <input type="number" min="0" [(ngModel)]="tamanho.qtdePedacos"
                       [disabled]="tamanhoExisteNoTemplate(tamanho)"
                       (ngModelChange)="aoEditarConfiguracaoPizza()">
              </label>
              <label class="ia-campo">
                <span>Máx. sabores</span>
                <input type="number" min="1" [(ngModel)]="tamanho.qtdeSabores"
                       [disabled]="tamanhoExisteNoTemplate(tamanho)"
                       (ngModelChange)="aoEditarConfiguracaoPizza()">
              </label>
            </div>
          </div>

          <p class="ia-pendencia" *ngIf="tamanhosNovosTemplatePizza.length > 0">
            <span class="fa fa-exclamation-triangle"></span>
            Serão acrescentados ao template existente: {{ tamanhosNovosTemplatePizza.join(', ') }}.
            Confira nomes equivalentes, como “P” e “Pequena”.
          </p>
          <p *ngIf="templatePizzaExistente && tamanhosExistentesTemplatePizza">
            <small>Tamanhos atuais do template: {{ tamanhosExistentesTemplatePizza }}.</small>
          </p>
        </section>

        <!-- avisos da leitura: pendências que não apontam para um produto específico -->
        <section class="ia-avisos" id="ia-avisos-leitura" *ngIf="pendenciasGerais.length > 0">
          <button type="button" class="ia-avisos__head" (click)="alterneAvisosLeitura()">
            <span class="fa fa-exclamation-triangle"></span>
            <strong>Avisos da leitura ({{ pendenciasGerais.length }})</strong>
            <small>pontos que a IA marcou para você conferir</small>
            <span class="fa" [ngClass]="avisosLeituraAbertos ? 'fa-angle-up' : 'fa-angle-down'"></span>
          </button>

          <ul class="ia-avisos__lista" *ngIf="avisosLeituraAbertos">
            <li *ngFor="let pendencia of pendenciasGerais">
              {{ pendencia.mensagem }}
            </li>
          </ul>
        </section>

        <section class="ia-categoria" *ngFor="let categoria of categoriasFiltradas; trackBy: trackPorReferencia"
                 [id]="'ia-categoria-' + categoria.draft.referencia">
          <header class="ia-categoria__head">
            <h3>{{ categoria.draft.nome || 'Sem nome' }} <small>· {{ categoria.produtos.length }} produtos</small></h3>
            <label class="ia-check-todos">
              <input type="checkbox" [checked]="todosSelecionados(categoria)" (change)="alterneCategoria(categoria)">
              todos
            </label>
          </header>

          <div class="ia-produtos">
            <div class="ia-produto" *ngFor="let produto of categoria.produtos; trackBy: trackPorReferencia"
                 [id]="'ia-produto-' + produto.draft.referencia"
                 [class.is-bloqueado]="produto.bloqueado"
                 [class.is-aberto]="produtoAberto === produto"
                 (click)="abraProduto(produto)">

              <label class="ia-produto__check" (click)="$event.stopPropagation()">
                <input type="checkbox"
                       [checked]="produto.draft.selecionado && !produto.bloqueado"
                       [disabled]="produto.bloqueado"
                       (change)="alterneSelecao(produto)">
              </label>

              <span class="ia-produto__thumb">
                <span class="fa fa-image"></span>
              </span>

              <div class="ia-produto__info">
                <div class="ia-produto__linha1">
                  <strong>{{ produto.draft.nome || 'Sem nome' }}</strong>
                  <span class="ia-chip-complementos" *ngIf="produto.draft.adicionais.length > 0">
                    +{{ produto.draft.adicionais.length }}
                    {{ produto.draft.adicionais.length === 1 ? 'complemento' : 'complementos' }}
                  </span>
                </div>
                <div class="ia-produto__linha2">
                  <ng-container *ngIf="produto.pendencias.length === 0">
                    <small>{{ produto.draft.descricao || '' }}</small>
                  </ng-container>
                  <ng-container *ngIf="produto.pendencias.length > 0">
                    <small class="ia-pendencia" [class.is-bloqueante]="produto.bloqueado">
                      <span class="fa" [ngClass]="produto.bloqueado ? 'fa-ban' : 'fa-exclamation-triangle'"></span>
                      {{ produto.pendencias[0].mensagem }}
                    </small>
                  </ng-container>
                </div>
              </div>

              <div class="ia-produto__preco" (click)="$event.stopPropagation()">
                <button type="button" class="ia-preco" *ngIf="!produto.editandoPreco"
                        [title]="produto.draft.tipoProduto === 'PIZZA' ? 'Menor preço entre os tamanhos' : 'Editar preço'"
                        (click)="produto.draft.tipoProduto !== 'PIZZA' && editePreco(produto, $event)">
                  <span class="ia-preco__eyebrow" *ngIf="produto.draft.preco != null">R$</span>
                  <span class="ia-preco__valor">{{ formatePreco(produto.draft.preco) }}</span>
                </button>
                <span class="ia-preco-editor" *ngIf="produto.editandoPreco">
                  <span class="ia-preco-editor__prefixo">R$</span>
                  <input [id]="'ia-preco-' + produto.draft.referencia"
                         type="text" inputmode="decimal"
                         [(ngModel)]="produto.precoEdicao"
                         (keydown.enter)="confirmePreco(produto)"
                         (keydown.escape)="cancelePreco(produto)"
                         (blur)="confirmePreco(produto)">
                </span>
              </div>
            </div>
          </div>
        </section>

        <div class="ia-vazio" *ngIf="categoriasFiltradas.length === 0">
          <p *ngIf="totalProdutos === 0">
            Não encontramos produtos neste cardápio. Confira se o arquivo mostra nomes e preços e tente de novo.
          </p>
          <button type="button" class="ia-secondary-btn" *ngIf="totalProdutos === 0" (click)="recomeceEnvio()">
            Enviar outro cardápio
          </button>
          <p *ngIf="totalProdutos > 0">Nenhum produto corresponde ao filtro atual.</p>
        </div>
      </div>
    </div>

    <!-- bulk bar -->
    <footer class="ia-bulk-bar" *ngIf="rascunho">
      <span class="ia-bulk-bar__info">{{ totalSelecionados }} de {{ totalProdutos }} selecionados</span>
      <span class="ia-erro" *ngIf="erroImportacao">{{ erroImportacao }}</span>
      <div class="ia-bulk-bar__acoes">
        <button type="button" class="ia-primary-btn" [disabled]="!podeImportar" (click)="abraConfirmacaoImportar()">
          <ng-container *ngIf="totalSelecionados > 0">
            Importar {{ totalSelecionados }} {{ totalSelecionados === 1 ? 'produto' : 'produtos' }}
          </ng-container>
          <ng-container *ngIf="totalSelecionados === 0">Importar produtos</ng-container>
        </button>
      </div>
    </footer>

    <!-- confirmação de importação -->
    <div class="ia-drawer-scrim" *ngIf="confirmandoImportacao" (click)="fecheConfirmacaoImportar()"></div>
    <div class="ia-dialog" *ngIf="confirmandoImportacao" role="dialog" aria-modal="true">
      <h3>Importar {{ totalSelecionados }} {{ totalSelecionados === 1 ? 'produto' : 'produtos' }} para o seu catálogo?</h3>
      <p *ngIf="totalProdutos - totalSelecionados > 0">
        {{ totalProdutos - totalSelecionados }}
        {{ totalProdutos - totalSelecionados === 1 ? 'produto ficará de fora' : 'produtos ficarão de fora' }}.
        Nada é publicado sem a sua revisão.
      </p>
      <p *ngIf="totalProdutos - totalSelecionados === 0">Nada é publicado sem a sua revisão.</p>
      <footer>
        <button type="button" class="ia-ghost-btn" (click)="fecheConfirmacaoImportar()">Voltar</button>
        <button type="button" class="ia-primary-btn" (click)="importeSelecionados()">Confirmar importação</button>
      </footer>
    </div>

    <!-- drawer de detalhe -->
    <div class="ia-drawer-scrim" *ngIf="produtoAberto" (click)="fecheProduto()"></div>
    <aside class="ia-drawer" *ngIf="produtoAberto">
      <header class="ia-drawer__head">
        <h3>{{ produtoAberto.draft.nome || 'Sem nome' }}</h3>
        <button type="button" class="ia-icon-btn" (click)="fecheProduto()" aria-label="Fechar">
          <span class="fa fa-times"></span>
        </button>
      </header>

      <div class="ia-drawer__corpo">
        <div class="ia-pendencias-drawer" *ngIf="produtoAberto.pendencias.length > 0">
          <p class="ia-pendencia" *ngFor="let pendencia of produtoAberto.pendencias"
             [class.is-bloqueante]="pendencia.bloqueiaImportacao">
            <span class="fa" [ngClass]="pendencia.bloqueiaImportacao ? 'fa-ban' : 'fa-exclamation-triangle'"></span>
            {{ pendencia.mensagem }}
          </p>
        </div>

        <label class="ia-campo">
          <span>Nome</span>
          <input type="text" [(ngModel)]="produtoAberto.draft.nome" (ngModelChange)="aoEditarCampo()">
        </label>

        <label class="ia-campo">
          <span>Categoria</span>
          <select [ngModel]="produtoAberto.categoria.draft.referencia"
                  (ngModelChange)="mudeCategoriaDoProduto(produtoAberto, $event)">
            <option *ngFor="let categoria of categorias" [value]="categoria.draft.referencia">
              {{ categoria.draft.nome || 'Sem nome' }}
            </option>
          </select>
        </label>

        <label class="ia-campo">
          <span>Tipo de produto</span>
          <select [ngModel]="produtoAberto.draft.tipoProduto"
                  (ngModelChange)="mudeTipoProduto(produtoAberto, $event)">
            <option [ngValue]="'NORMAL'">Produto normal</option>
            <option [ngValue]="'PIZZA'">Sabor de pizza</option>
          </select>
        </label>

        <label class="ia-campo">
          <span>{{ produtoAberto.draft.tipoProduto === 'PIZZA' ? 'Menor preço dos tamanhos' : 'Preço' }}</span>
          <span class="ia-campo__prefixado">
            <em>R$</em>
            <input type="number" step="0.01" min="0"
                   [disabled]="produtoAberto.draft.tipoProduto === 'PIZZA'"
                   [(ngModel)]="produtoAberto.draft.preco" (ngModelChange)="aoEditarCampo()">
          </span>
        </label>

        <label class="ia-campo">
          <span>Descrição</span>
          <textarea rows="3" [(ngModel)]="produtoAberto.draft.descricao" (ngModelChange)="aoEditarCampo()"></textarea>
        </label>

        <div class="ia-grupos" *ngIf="produtoAberto.draft.adicionais.length > 0">
          <h4>Grupos de adicionais</h4>

          <div class="ia-grupo" *ngFor="let grupo of produtoAberto.draft.adicionais">
            <button type="button" class="ia-grupo__head" (click)="alterneGrupo(grupo)">
              <span class="fa" [ngClass]="grupoAberto === grupo ? 'fa-angle-down' : 'fa-angle-right'"></span>
              <strong>{{ grupo.nome || 'Sem nome' }}</strong>
              <small>{{ descricaoDoGrupo(grupo) }}</small>
            </button>

            <div class="ia-grupo__corpo" *ngIf="grupoAberto === grupo">
              <label class="ia-check-todos" *ngIf="produtoAberto.draft.tipoProduto === 'PIZZA'">
                <input type="radio" [checked]="ehGrupoTamanhoPizza(produtoAberto, grupo)"
                       (change)="definaGrupoTamanhoPizza(produtoAberto, grupo)">
                Este grupo contém os tamanhos da pizza
              </label>

              <label class="ia-campo">
                <span>Nome do grupo</span>
                <input type="text" [(ngModel)]="grupo.nome" (ngModelChange)="aoEditarCampo()">
              </label>

              <div class="ia-campo-linha" *ngIf="!ehGrupoTamanhoPizza(produtoAberto, grupo)">
                <label class="ia-campo">
                  <span>Tipo</span>
                  <select [(ngModel)]="grupo.tipoSelecao" (ngModelChange)="aoEditarCampo()">
                    <option [ngValue]="'SIMPLES'">Escolha única</option>
                    <option [ngValue]="'MULTIPLA'">Múltipla escolha</option>
                  </select>
                </label>
                <label class="ia-campo">
                  <span>Mínimo</span>
                  <input type="number" min="0" [(ngModel)]="grupo.minimo" (ngModelChange)="aoEditarCampo()">
                </label>
                <label class="ia-campo">
                  <span>Máximo</span>
                  <input type="number" min="1" [(ngModel)]="grupo.maximo" (ngModelChange)="aoEditarCampo()">
                </label>
              </div>

              <div class="ia-opcao" *ngFor="let opcao of grupo.opcoes">
                <input type="text" class="ia-opcao__nome"
                       [(ngModel)]="opcao.nome" (ngModelChange)="aoEditarCampo()" placeholder="Nome da opção">
                <span class="ia-campo__prefixado ia-opcao__preco">
                  <em>R$</em>
                  <input type="number" step="0.01" min="0"
                         [title]="ehGrupoTamanhoPizza(produtoAberto, grupo) ? 'Preço cheio deste tamanho' : 'Preço da opção'"
                         [(ngModel)]="opcao.preco" (ngModelChange)="aoEditarCampo()">
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="ia-evidencia" *ngIf="evidenciaPrincipal(produtoAberto) as evidencia">
          <h4>Origem</h4>
          <p class="ia-evidencia__trecho">“{{ evidencia.trecho }}”</p>
          <p class="ia-evidencia__meta">
            página {{ evidencia.pagina }} ·
            <span class="ia-evidencia__estado"
                  [class.is-extraido]="evidencia.estado === 'EXTRAIDO'"
                  [class.is-inferido]="evidencia.estado === 'INFERIDO'"
                  [class.is-conflitante]="evidencia.estado === 'CONFLITANTE' || evidencia.estado === 'AUSENTE'">
              {{ rotuloEvidencia(evidencia.estado) }}
              <span class="fa fa-check" *ngIf="evidencia.estado === 'EXTRAIDO'"></span>
            </span>
          </p>
        </div>

        <button type="button" class="ia-ghost-btn ia-ghost-btn--danger" (click)="removaProduto(produtoAberto)">
          Remover este produto
        </button>
      </div>
    </aside>
  </section>

  <!-- ═══════════ ETAPA 4: CONCLUIR ═══════════ -->
  <section class="ia-etapa ia-etapa--concluir" *ngIf="etapa === 'concluir'">
    <div class="ia-solo">
      <div class="ia-card">

      <ng-container *ngIf="importando">
        <div class="ia-status-head">
          <span class="ia-analise__icone">
            <span class="fa fa-circle-notch fa-spin"></span>
          </span>
          <div class="ia-status-head__textos">
            <h2 class="ia-analise__titulo">Importando produtos…</h2>
            <p class="ia-analise__arquivo">Cada produto é gravado individualmente. Isso leva poucos segundos.</p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!importando && resultadoImportacao">
        <div class="ia-resultado">
          <div class="ia-resultado__linha ia-resultado__linha--sucesso">
            <span class="fa fa-check"></span>
            <strong>{{ resultado.importados.length }}</strong>
            {{ resultado.importados.length === 1 ? 'produto importado' : 'produtos importados' }} para o catálogo
          </div>
          <div class="ia-resultado__linha" *ngIf="ignorados.length > 0">
            <span class="fa fa-minus-circle"></span>
            <strong>{{ ignorados.length }}</strong> deixados de fora por você
          </div>
          <div class="ia-resultado__linha ia-resultado__linha--falha" *ngIf="resultado.falhas.length > 0">
            <span class="fa fa-times"></span>
            <strong>{{ resultado.falhas.length }}</strong> com falha
          </div>
        </div>

        <div class="ia-falhas" *ngIf="resultado.falhas.length > 0">
          <h4>Falhas</h4>
          <div class="ia-falha" *ngFor="let falha of resultado.falhas">
            <div class="ia-falha__info">
              <strong>{{ falha.nome || nomeDaReferencia(falha.referencia) }}</strong>
              <small>{{ falha.mensagem }}</small>
            </div>
            <button type="button" class="ia-secondary-btn" (click)="revejaProduto(falha.referencia)">
              Rever produto
            </button>
          </div>

          <button type="button" class="ia-secondary-btn"
                  [disabled]="reimportando" (click)="tenteNovamenteFalhas()">
            <span class="fa fa-circle-notch fa-spin" *ngIf="reimportando"></span>
            Tentar novamente
            {{ resultado.falhas.length === 1 ? 'a falha' : 'as ' + resultado.falhas.length + ' falhas' }}
          </button>
        </div>

        <p class="ia-erro" *ngIf="erroImportacao">{{ erroImportacao }}</p>

        <footer class="ia-card__footer">
          <button type="button" class="ia-ghost-btn" (click)="recomeceEnvio()">Importar outro cardápio</button>
          <button type="button" class="ia-primary-btn" (click)="volteParaProdutos()">{{ embutido ? 'Concluir' : 'Ver produtos no catálogo' }}</button>
        </footer>
      </ng-container>
      </div>
    </div>
  </section>
</div>
